/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

export default class Photochromatic {
    private json: any
    public readonly linkTitle: string
    public readonly left: { url: string; alt: string; label: string; }
    public readonly right: { url: string; alt: string; label: string; }

    constructor (json: any, isTier?: boolean) {
      this.json = json
      if (!isTier) {
        this.linkTitle = json.education_slider_link.title
        this.left = {
          url: json.slider_images[0].slider_image.url,
          alt: json.slider_images[0].slider_image_alt_text,
          label: json.slider_images[0].slider_image_label
        }
        this.right = {
          url: json.slider_images[1].slider_image.url,
          alt: json.slider_images[1].slider_image_alt_text,
          label: json.slider_images[1].slider_image_label
        }
      } else {
        this.linkTitle = json.subop_slider_link.title
        this.left = {
          url: json.subop_slider_images[0].subop_slider_image.url,
          alt: json.subop_slider_images[0].subop_slider_alt_text,
          label: json.subop_slider_images[0].subop_slider_label
        }
        this.right = {
          url: json.subop_slider_images[1].subop_slider_image.url,
          alt: json.subop_slider_images[1].subop_slider_alt_text,
          label: json.subop_slider_images[1].subop_slider_label
        }
      }
    }

    static of (json: any, isTier?: boolean): Photochromatic {
      return new Photochromatic(json, isTier)
    }
}
